import {AuwBaseComponent} from "EXT/auw_config/Resources/Private/Js/AuwBaseComponent";

export class AuwCookieBanner extends AuwBaseComponent{

    constructor($el){
        super($el);

        this.config = {
            days: "1",
            cookieName: "cookieAcceptanceLevel",
            cookieBannerClass: ".cookie-banner"
        }

    }

    __WindowLoad(){
        if(this.readCookie(this.config.cookieName) == null){
            this.showBanner();
            this.$el.find('.cookie-banner__close').on('click', this.hideBanner.bind(this));
        }
    }

    showBanner(){
        this.$el.show();

        this.$el.insertBefore( "#view-box-site" );

        var cookieBannerOptionContainer = $('.cookie-banner__option-container');

        var cookieBannerToggleOnText = $('.cookie-banner__more').data('toggleon');
        var cookieBannerToggleOffText = $('.cookie-banner__more').data('toggleoff');

        $(document).on('click', '.cookie-banner__more', function() {
            cookieBannerOptionContainer.slideToggle(200);
            cookieBannerOptionContainer.toggleClass('more-is-clicked');

            if (cookieBannerOptionContainer.hasClass('more-is-clicked')) {
                $('.cookie-banner__more').text(cookieBannerToggleOffText);
            } else {
                $('.cookie-banner__more').text(cookieBannerToggleOnText);
            }
        });

        var optionNamePlace = $('.cookie-banner__option-name');
        var optionNameChecked = $('.cookie-banner__option-container--flex .radio input:checked');
        var optionName = optionNameChecked.next('p').find('strong').html();
        //optionNamePlace.text('"standard"');

        $(document).on('click', '.cookie-banner__option-container--flex .radio', function() {
            optionNameChecked = $('.cookie-banner__option-container--flex .radio input:checked');
            optionName = optionNameChecked.next('p').find('strong').html();
            optionNamePlace.text('"' + optionName + '"');
        })
    }

    hideBanner(){
        var value=this.$el.find('input[name=acceptanceLevelChoice]:checked').val()
        if(!value){
            //war hidden field
            value = this.$el.find('input[name=acceptanceLevelChoice]').val();
        }
        this.createCookie(this.config.cookieName,value,this.config.days);
        window.location.reload();
    }

}
